(function () {
    'use strict';

    angular.module('swif.ui')
    .component('swifBreadcrumb', {
        templateUrl: 'partials/ui/breadcrumb.html',
        controller: SwifBreadcrumbCtrl,
        bindings: {
            breadcrumb_names: '@?'
        },
        require: 'ngModel'
    })
    .directive('swifInputSelectBreadcrumb', swifInputSelectBreadcrumb);


    /**
     *
     * @ngdoc directive
     * @name swif.ui:swifBreadcrumb
     * @module swif.ui
     * @descrition
     * This component provide a selectable breadcrumb for site content type
     * It is used in the patrimoine referentiel
     * @restrict E
     *
     * @usage
        <swif-breadcrumb
            ng-model="referentiel"
            breadcrumb-field="breadcrumb_names">
        </swif-breadcrumb>
     */
    function SwifBreadcrumbCtrl($scope, $element, swif) {
        'ngInject';
        var $ctrl = this;

        this.breadcrumb_names = this.breadcrumb_names || 'breadcrumb_names';
        this.parents_filters = {};
        this.parents_loading = true;
        this.model_parents = {};
        this.current_filter = {};
        this.current_loading = true;
        this.current = {};
        this.children_filter = {};
        this.children_loading = true;
        this.children = {};
        this.hasChildren = false;

        $scope.$watch('$ctrl.current.selected', watchSelected);
        $scope.$watch('$ctrl.children.selected', watchChildrenSelected, true);
        $scope.$watch('$ctrl.model_parents', watchParents, true);
        $scope.$watch('$ctrl.collection.currentItem.id', watchCurrentItem);

        this.$onInit = function () {
            this.ngModel = $element.controller('ngModel');
            $ctrl.ngModel.$render = function () {
                $ctrl.collection = $ctrl.ngModel.$viewValue;
            };
        };

        function setCurrentItem(item) {
            $ctrl.collection.setCurrent(item);
        }

        function setChildrenFilter(id) {
            var filter = {};
            filter.fields = ['id', 'name'];
            swif.data.addFilter(filter, 'site_parent_id', '=', id);
            $ctrl.children_filter = filter;
        }

        function setParentFilter(crumb) {
            var index = $ctrl.parents.indexOf(crumb);
            var parent;
            if (index > 0) {
                parent = $ctrl.parents[index - 1];
            } else {
                parent = [false];
            }
            var filter = {};
            filter.fields = ['id', 'name'];
            swif.data.addFilter(filter, 'site_parent_id', '=', parent[0]);
            $ctrl.parents_filters[crumb[0]] = filter;
        }

        function setCurrentFilter() {
            var filter = {};
            var current = $ctrl.collection.currentItem;
            filter.fields = ['id', 'name', 'complete_name'];
            if (current) {
                if (current.site_parent_id) {
                    swif.data.addFilter(filter, 'site_parent_id', '=', current.site_parent_id[0]);
                    $ctrl.current_filter = filter;
                }
            }
        }

        function loadBreadcrumb() {
            var currentItem = $ctrl.collection.currentItem;
            //parent
            if (currentItem && currentItem.breadcrumb_names) {
                $ctrl.parents_loading = true;
                $ctrl.parents = angular.copy(currentItem.breadcrumb_names).reverse();
                $ctrl.model_parents = {};
                _.forEach($ctrl.parents, function (crumb) {
                    $ctrl.model_parents[crumb[0]] = [crumb[0], crumb[1]];
                    setParentFilter(crumb);
                });
                $ctrl.parents_loading = false;
            }

            //current
            $ctrl.current_loading = true;
            setCurrentFilter();
            $ctrl.current.selected = [
                currentItem.id, $ctrl.collection.currentItem.name
            ];
            $ctrl.current_loading = false;

            //children
            $ctrl.children_loading = true;
            setChildrenFilter(currentItem.id);
            $ctrl.children = {};
            $ctrl.children_loading = false;
        }

        function hasChildren() {
            swif.data.getContentRange(
                $ctrl.collection.contentType,
                $ctrl.children_filter
            ).then(function (result) {
                $ctrl.hasChildren = result;
            });
        }

        function watchCurrentItem(newV) {
            if (newV) {
                $ctrl.hasChildren = false;
                loadBreadcrumb();
                hasChildren();
            }
        }

        function watchSelected(newV) {
            if (newV === undefined || $ctrl.current_loading) {
                return;
            }
            if (newV[0] === $ctrl.collection.currentItem.id) {
                return;
            }
            if (newV === false) {
                var parent = _.findLast($ctrl.parents);
                if (parent) {
                    setCurrentItem(parent[0]);
                } else {
                    setCurrentItem();
                }
            } else {
                setCurrentItem(newV[0]);
            }
        }

        function watchChildrenSelected(newV) {
            if (!newV || $ctrl.children_loading) {
                return;
            }
            setCurrentItem(newV[0]);
        }

        function watchParents(newV) {
            if (!newV || $ctrl.parents_loading) {
                return;
            }
            _.forOwn(newV, function (value, key) {
                if (value !== false && value[0] !== parseInt(key, 10)) {
                    $ctrl.parents_loading = true;
                    setCurrentItem(value[0]);
                }
            });
        }
    }


    /**
     *
     * @ngdoc directive
     * @name swif.ui:swifInputSelectBreadcrumb
     * @module swif.ui
     * @restrict E
     *
     * @usage

        <swif-input-select-breadcrumb
            ng-model="ngModel.site1"
            ng-required="ngRequired"
            restrict-ids="filter.restrictIds"
            breadcrumb-field="breadcrumb_ids"
            parent-field="site_parent_id"
            icon="fa-map-marker"
            filter="filter.sites">
        </swif-input-select-breadcrumb>

     * @descrition
     * This component provide an input select one that works with site content type
     * It is used in the patrimoine referentiel
     *
     */

    function swifInputSelectBreadcrumb (swif, gettextCatalog) {
        'ngInject';
        return {
            restrict: 'E',
            templateUrl: 'partials/ui/inputSelectBreadcrumb.html',
            require: 'ngModel',
            scope: {
                breadcrumbField: '@?',
                parentField: '@',
                helpText: '@',
                filter: '=?',
                restrictIds: '=?',
                ngRequired: '=?',
                icon: '@?'
            },
            link: function (scope, element, attr, ngModel) {
                scope._ = _;
                var initialize = function () {
                    scope.displayInput = false;
                    scope.fields = ['name', 'complete_name', 'site_code'];
                    scope.breadcrumbField = scope.breadcrumbField || 'breadcrumb_names';
                    scope.proxy = {selected: false, items: [], fake: {value: false, filter: {fields: scope.fields}}};
                    updateFilters();
                };

                scope.translate = {
                    'bePrecise': gettextCatalog.getString('Could you be more precise ?'),
                    'exactName': gettextCatalog.getString('the exact name'),
                    'hierarchy': gettextCatalog.getString('on the entire hierarchy')
                };

                ngModel.$render = function () {
                    var vv = ngModel.$viewValue;
                    if (vv) {
                        updateProxyItems(vv)
                        .then(function (data) {
                            setSelected();
                            updateFilters();
                        });
                    }
                };

                var setViewValue = function () {
                    ngModel.$setViewValue(scope.proxy.selected);
                };
                var getFilter = function () {
                    var filter = {};
                    if (scope.filter) {
                        filter = angular.copy(scope.filter);
                    }
                    filter.fields = scope.fields;
                    return filter;
                };
                scope.toggleCompleteName = function () {
                    if (scope.fields.length === 1) {
                        scope.fields[1] = 'complete_name';
                        scope.proxy.fake.nameOnly = false;
                    } else {
                        scope.fields.splice(1, 1);
                        scope.proxy.fake.nameOnly = true;
                    }
                };
                scope.deleteSelected = function () {
                    scope.proxy.items = [];
                    setSelected();
                    updateFilters();
                    setViewValue();
                };
                scope.selectParent = function () {
                    if (scope.restrictIds) {
                        if (_.contains(scope.restrictIds, scope.proxy.selected[0])) {
                            return;
                        }
                    }
                    scope.proxy.items.pop();
                    setSelected();
                    updateFilters();
                    setViewValue();
                };
                var updateFilters = function () {
                    var fakeFilter = getFilter();
                    if (scope.proxy.selected) {
                        swif.data.addFilter(
                            fakeFilter,
                            scope.parentField, '=',
                            scope.proxy.selected[0]
                        );
                    }
                    scope.proxy.fake.filter = fakeFilter;
                    scope.displayInput = false;
                    swif.data.getContentRange('site', scope.proxy.fake.filter)
                    .then(function (count) {
                        scope.displayInput = count > 0;
                    });
                };

                var updateProxyItems = function (lastSite) {
                    return swif.data.get('site', lastSite[0], {fields: [scope.breadcrumbField]})
                    .then(function (data) {
                        var items = [];
                        var ids = data[scope.breadcrumbField];
                        var filter = {fields: ['name']};
                        if (_.isEmpty(ids)) {
                            ids = [];
                        }
                        ids.splice(0, 0, lastSite[0]);
                        swif.data.addFilter(filter, 'id', 'in', ids);
                        return swif.data.searchRead('site', filter).then(function (sites) {
                            var orderedSites = {};
                            _.forEach(sites.records, function (val) {
                                orderedSites[val.id] = [val.id, val.name];
                            });
                            _.forEach(ids, function (id) {
                                var item = {value: orderedSites[id]};
                                items.splice(0, 0, item);
                            });
                            scope.proxy.items = items;
                            return scope.proxy.items;
                        });
                    });
                };

                var setSelected = function () {
                    var last = scope.proxy.items[scope.proxy.items.length - 1];
                    if (last) {
                        scope.proxy.selected = last.value;
                    } else {
                        scope.proxy.selected = false;
                    }
                    scope.proxy.hasValue = scope.proxy.selected ? true: undefined;
                };

                scope.onFakeChanged = function () {
                    var val = scope.proxy.fake.value;
                    if (val) {
                        scope.proxy.fake.value = false;
                        updateProxyItems(val).then(function () {
                            setSelected();
                            updateFilters();
                            setViewValue();
                        });
                    }
                };

                // when an item is changed inside the breadcrumb,
                // we just update filters and let selectOne to apply the filter
                // => we only remove the item if the value is cleared
                scope.onItemChanged = function (item, index) {
                    if (!item.value) {
                        scope.proxy.items.splice(index, 1);
                    }
                    setSelected();
                    updateFilters();
                    setViewValue();
                };
                scope.$watch('filter', function (newV) {
                    updateFilters();
                }, true);
                initialize();
            }
        };
    }

})();
